<script setup lang="ts">
</script>

<template>
  <div class="border-b border-white-gray -mx-2"></div>
</template>

<style scoped>
</style>
